import { render, staticRenderFns } from "./CreateChannelPartnerAgreementPopUp.vue?vue&type=template&id=18a7c104&scoped=true"
import script from "./CreateChannelPartnerAgreementPopUp.vue?vue&type=script&lang=js"
export * from "./CreateChannelPartnerAgreementPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateChannelPartnerAgreementPopUp.vue?vue&type=style&index=0&id=18a7c104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a7c104",
  null
  
)

export default component.exports